import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CreateCase from './components/CreateCase';
import Navigation from './components/Navigation';
import BackgroundCarousel from './components/BackgroundCarousel';
import Docs from './components/Docs';
import Blinks from './components/Blinks';
import BlinkPreview from './components/BlinkPreview';
import HowToPlay from './components/HowToPlay';
import PhantomBanner from './components/PhantomBanner';
import History from './components/History';
import Rewards from './components/Rewards';
import LaunchGate from './components/LaunchGate';

function App() {
  const [isUnlocked, setIsUnlocked] = useState(() => {
    return sessionStorage.getItem('bloot_unlocked') === 'true';
  });

  const handleUnlock = () => {
    setIsUnlocked(true);
    sessionStorage.setItem('bloot_unlocked', 'true');
  };

  return (
    <BrowserRouter>
      <div className="app">
        <PhantomBanner />
        <BackgroundCarousel />
        <div className="main-layout">
          <div className="content-container">
            {isUnlocked ? (
              <>
                <Header />
                <Routes>
                  <Route 
                    path="/" 
                    element={
                      <>
                        <HeroSection />
                        <CreateCase />
                      </>
                    } 
                  />
                  <Route path="/create" element={
                    <>
                      <HeroSection />
                      <CreateCase />
                    </>
                  } />
                  <Route path="/blinks" element={<Blinks />} />
                  <Route path="/preview/:id" element={<BlinkPreview />} />
                  <Route path="/docs" element={<Docs />} />
                  <Route path="/how-to-play" element={<HowToPlay />} />
                  <Route path="/history" element={<History />} />
                  <Route path="/rewards" element={<Rewards />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </>
            ) : (
              <LaunchGate onUnlock={handleUnlock} />
            )}
          </div>
        </div>
        {isUnlocked && <Navigation />}
      </div>
    </BrowserRouter>
  );
}

export default App;
